import React from "react";
import { cases } from "../data/content";
export function Cases() {
  return <section id="resultados" className="bg-ink-2" data-id="element-15" data-mp="1xul05fbmbbby">
      <div className="mx-auto max-w-5xl px-6 py-16 sm:py-24" data-id="element-16" data-mp="1xt9vldaclzjs">
        <h2 className="mb-6 font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-17" data-mp="22l1fx62wv91h">
          Personas que dieron sus primeros pasos
        </h2>
        <div className="grid gap-5 md:grid-cols-2" data-id="element-18" data-mp="26md9tnstigfh">
          {cases.map(c => <article key={c.name} className="rounded-xl border border-line p-7" data-id="element-19" data-mp="19ygok5mfqwxx">
              <p className="mb-3 text-sm text-accent" data-id="element-20" data-mp="1ex0d8dseymtz">{c.name}</p>
              <h3 className="font-serif text-2xl font-bold leading-snug" data-id="element-21" data-mp="1ixtw2sr01bg0">{c.result}</h3>
            </article>)}
        </div>
        <p className="mt-5 text-sm leading-relaxed text-soft" data-id="element-22" data-mp="1nxgb97qe11rg">
          Son experiencias individuales. Los resultados y los tiempos dependen de la implementación, la propuesta y la
          demanda.
        </p>
      </div>
    </section>;
}